import findUp from 'find-up';

export function getPackageJsonForPath(filePath: string): any {
  const packageJson = findUp.sync('package.json', { cwd: filePath });
  if (packageJson) {
    return require(packageJson);
  }
  return null;
}
